import React, { ReactNode }                         from "react";
import { connect }                                  from "react-redux";
import Customer                                     from "../../../domain/customer/Customer";
import CustomerRepository                           from "../../../domain/customer/CustomerRepository";
import MenuType                                     from "../../../domain/menu/MenuType";
import { ResKaState }                               from "../../../index";
import CustomerDataSource
                                                    from "../../../infrastructure/datasource/customer/CustomerDataSource";
import Breadcrumbs                                  from "../../components/common/Breadcrunmbs";
import BackHistoryButton                            from "../../components/common/BuckHistoryButton";
import BottomSection                                from "../../components/common/layout/BottomSection";
import TopSection                                   from "../../components/common/layout/TopSection";
import CustomerForm                                 from "../../components/customer/CustomerForm";
import CustomerRegisterButton                       from "../../components/customer/CustomerRegisterButton";
import ResKaBaseContainer, { BaseProps, BaseState } from "../ResKaBaseContainer";

interface Props extends BaseProps {
  repository: CustomerRepository;
}

class CustomerRegisterContainer extends ResKaBaseContainer<Props, BaseState> {
  constructor(props: Props) {
    const state = {
      headerTitle: "顧客追加",
      menuType: MenuType.CUSTOMER,
    };

    super(props, state);
  }

  protected componentDidMountInternal(): void {
    this.props.repository.setCustomer(new Customer());
  }

  protected renderInternal(): ReactNode {
    return (
      <>
        <TopSection>
          <Breadcrumbs breadcrumbs={
            [
              {
                title: "顧客一覧",
                path: "/customers"
              },
              {
                title: "顧客追加",
                path: "/customer/register"
              },
            ]
          }/>
        </TopSection>

        <TopSection>
          <CustomerRegisterButton/>
          <BackHistoryButton path="/customers"/>
        </TopSection>

        <CustomerForm/>

        <BottomSection>
          <CustomerRegisterButton/>
          <BackHistoryButton path="/customers"/>
        </BottomSection>
      </>
    );
  }
}

const mapStateToProps = (state: ResKaState) => ({
  fetchStatus: state.fetchStatus,
});
const mapDispatchToProps = (dispatch) => ({
  repository: new CustomerDataSource(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerRegisterContainer);
